import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import {
  DocumentActionClose,
  DocumentActionDownload,
  DocumentActionDownloadAsPdf,
  DocumentActionLogout,
  DocumentActionModel,
  DocumentActionNew,
  DocumentActionOpen,
  DocumentActionOpenNewTab,
  DocumentActionPrint,
  DocumentActionSave,
  DocumentActionSaveAs,
  DocumentActionUpload,
} from 'src/app/models/document-action.model';
import { DocumentModel } from 'src/app/models/document.model';
import { FileMenuActions } from 'src/app/models/file-menu.model';
import { DocumentService } from 'src/app/services/document.service';

@Component({
  selector: 'tx-file-menu-dialog',
  templateUrl: './file-menu-dialog.component.html',
  styleUrls: ['./file-menu-dialog.component.scss'],
})
export class FileMenuDialogComponent implements OnInit {
  @Input() document: DocumentModel;
  @Input() uploadedDocument: DocumentModel;
  @Input() preselectedComponent: string;
  @Input() isPdf: boolean = false;
  @Input() isDirty = false;
  public activeComponent: string;
  public fileMenuActions = FileMenuActions;

  constructor(public activeOffcanvas: NgbActiveOffcanvas, private documentService: DocumentService) {
    this.preselectedComponent = '';
    this.activeComponent = '';
    this.document = {
      isActiveDocument: true,
      saveAsPdf: false,
      answersChanged: false,
      openInAnotherSession: false,
      pdfAnswersChanged: false,
      txdocsAnswersChanged: false,
    };
    this.uploadedDocument = {
      isActiveDocument: false,
      saveAsPdf: false,
      answersChanged: false,
      openInAnotherSession: false,
      pdfAnswersChanged: false,
      txdocsAnswersChanged: false,
    };
  }

  ngOnInit(): void {
    // if there is a preselected component (example: pressing ctrl + S or ctrl + O) set that as the active component
    if (this.preselectedComponent != null && this.preselectedComponent !== '') {
      this.activeComponent = this.preselectedComponent;
    } else {
      //dirty document - SaveAs will be default : children components handle if document is case or firm document type
      this.activeComponent = this.isDirty ? FileMenuActions.SaveAs : FileMenuActions.Open;
    }
  }

  onOpenClicked() {
    this.activeComponent = FileMenuActions.Open;
  }

  onSaveAsClicked() {
    this.activeComponent = FileMenuActions.SaveAs;
  }

  openDocument(e: any) {
    const result: DocumentActionModel = {
      action: DocumentActionOpen,
      document: e,
    };

    this.activeOffcanvas.close(result);
  }

  openDocumentInNewTab(e: any) {
    this.activeOffcanvas.close();
  }

  onNewClicked() {
    this.activeComponent = FileMenuActions.New;
  }

  openNewDocument(e: any) {
    const result: DocumentActionModel = {
      action: DocumentActionNew,
      case: e,
    };

    this.activeOffcanvas.close(result);
  }

  onSaveClicked() {
    console.dir('document on save clicked', this.document);
    // it's an existing case document or a firm document
    // the old if statement made firm documents impossible to save because they don't have a dcmID
    if (this.document.dcmID || (!this.document.dcmID && !this.document.casID)) {
      const result: DocumentActionModel = {
        action: DocumentActionSave,
      };

      this.activeOffcanvas.close(result);
    } else {
      this.onSaveAsClicked();
    }
  }

  saveDocumentAs(document: DocumentModel) {
    const result: DocumentActionModel = {
      action: DocumentActionSaveAs,
      document: document,
    };

    this.activeOffcanvas.close(result);
  }

  printDocument() {
    const result: DocumentActionModel = {
      action: DocumentActionPrint,
    };

    this.activeOffcanvas.close(result);
  }

  onDownloadClicked() {
    this.activeComponent = FileMenuActions.Download;
  }

  downloadDocument(downloadAsPdf: boolean) {
    const action: string = downloadAsPdf ? DocumentActionDownloadAsPdf : DocumentActionDownload;
    const result: DocumentActionModel = {
      action: action,
    };

    this.activeOffcanvas.close(result);
  }

  onUploadClicked() {
    this.activeComponent = FileMenuActions.Upload;
  }

  uploadDocument(e: DocumentModel) {
    const result: DocumentActionModel = {
      action: DocumentActionUpload,
      document: e,
    };
    this.activeOffcanvas.close(result);
  }

  logout() {
    const result: DocumentActionModel = {
      action: DocumentActionLogout,
    };

    this.activeOffcanvas.close(result);
  }

  onCloseClicked() {
    const result: DocumentActionModel = {
      action: DocumentActionClose,
    };

    this.activeOffcanvas.close(result);
  }
}
